import { createSlice } from "@reduxjs/toolkit";
import { DeleteProductsThunk, EditProductsThunk, GetForBonusProductsThunk, GetProductsThunk } from "../actions/products";

const initialState = {
  list: [] as any[],
  info: {} as any,
  bonuses:[] as any[],
  status: "pending" as statusType,
  error: undefined as string | any,
  fetchTimes: 0,
  filters: {} as any,
};

export const ProductsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setFilters: (state, { payload }) => {
      state.filters = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // get transactions
      .addCase(GetProductsThunk.pending, (state) => {
        state.status = "pending";
        state.fetchTimes += 1;
      })
      .addCase(GetProductsThunk.rejected, (state) => {
        state.status = "error";
      })
      .addCase(GetProductsThunk.fulfilled, (state, { payload, meta: { arg } }) => {
        const { list, ...info } = payload;
        state.status = "success";
        if (arg) state.filters = arg;
        state.list = list;
        state.info = info;
      })
      .addCase(GetForBonusProductsThunk.fulfilled, (state, { payload, meta: { arg } }) => {
        const { list, ...info } = payload;
        state.status = "success";
        if (arg) state.filters = arg;
        state.bonuses = list;
        state.info = info;
      })

      // add products
      // .addCase(AddProductsThunk.fulfilled, (_, { payload }) => {
      //   console.log({ payload });
      // })
      // edit products
      .addCase(EditProductsThunk.fulfilled, (state, { meta: { arg } }) => {
        const index = state.list?.findIndex((s) => s?.id == arg?.id);
        if (index >= 0) {
          state.list[index] = { ...state.list[index], ...arg?.data };
        }
      })
      // delete products
      .addCase(DeleteProductsThunk.fulfilled, (state, { meta: { arg } }) => {
        state.list = state.list?.filter((s) => s?.id != arg?.id);
      });
  },
});

export const { setFilters } = ProductsSlice.actions;
export default ProductsSlice.reducer;
